import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constants';
import LogoutConstant from '../../MainFrame/constants/Constants';
import restClient from '../../MainFrame/action/APIClient';

var DeletePortfolioProfilesAction = function () {

}


DeletePortfolioProfilesAction.prototype = {

	deletePortfolioProfile: function (profileId,portfolioId) {

		restClient.deletePortfolioProfile(profileId,portfolioId, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else{
					AppDispatcher.dispatch({
						actionType: Constant.DELETE_PORTFOLIO_PROFILE,
						data: error
					});
				}
			} else {
				response['status']= 200;
				AppDispatcher.dispatch({
					actionType: Constant.DELETE_PORTFOLIO_PROFILE,
					data: response
				});
			}
		})
	}
}

export default new DeletePortfolioProfilesAction();